import { render, staticRenderFns } from "./SkinToggler.vue?vue&type=template&id=771d7ac4&"
import script from "./SkinToggler.vue?vue&type=script&lang=js&"
export * from "./SkinToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports